import Cookies from 'js-cookie';
import { getLanguage } from '@/lang/index';

const state = {
  sidebar: {
    opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
    withoutAnimation: false,
  },
  device: 'desktop',
  size: Cookies.get('size') || 'medium',
  language: getLanguage(),
  render:false,
  is_pro_env: false,
  reachBottom:{
    time:0,
  },
  hiddenTag:false,
  isMobile:false,
};

const mutations = {
  TOGGLE_SIDEBAR: (state) => {
    state.sidebar.opened = !state.sidebar.opened;
    state.sidebar.withoutAnimation = false;
    if (state.sidebar.opened) {
      Cookies.set('sidebarStatus', 1);
    } else {
      Cookies.set('sidebarStatus', 0);
    }
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    Cookies.set('sidebarStatus', 0);
    state.sidebar.opened = false;
    state.sidebar.withoutAnimation = withoutAnimation;
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device;
  },
  SET_LANGUAGE: (state, language) => {
    state.language = language;
    Cookies.set('language', language, { path: '/', domain: '.qq.com' });
  },
  SET_SIZE: (state, size) => {
    state.size = size;
    Cookies.set('size', size);
  },
  SET_REACH_BOTTOM:(state, info)=>{
    state.reachBottom = info;
 },
  SET_REACH_MOBILE:(state, isMobile)=>{
    state.isMobile = isMobile;
 },
};

const actions = {
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR');
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit('CLOSE_SIDEBAR', withoutAnimation);
  },
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device);
  },
  setLanguage({ commit }, language) {
    commit('SET_LANGUAGE', language);
  },
  setSize({ commit }, size) {
    commit('SET_SIZE', size);
  },
  setReachBottomInfo({ commit },info){
    commit('SET_REACH_BOTTOM', info);
  },
  setIsMobileInfo({ commit },isMobile){
    commit('SET_REACH_MOBILE', isMobile);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
